<template>
  <v-container fluid>
    <h1 class="headline">What is this?</h1>
    <p class="mt-1">This is an app I made one evening as I was sitting at home bored out of my mind. It provides some quick visualizations of the Covid-19 dataset that New York Times has graciously made available to the public.</p>
    <h1 class="headline">What kinds of visualizations?</h1>
    <p class="mt-1">Nothing crazy. Definitely don't expect <a target="_blank" href="https://www.nytimes.com/interactive/2020/us/coronavirus-us-cases.html">super 
    fancy stuff like the people at New York Times create</a>.</p>
    <p>This app just takes the data, breaks it down by state and displays that state's cases and casulties on simple line charts.</p>
    <h1 class="headline">Is the data "live"?</h1>
    <p class="mt-1">Every time you refresh this web page, the most up-to-date version is fetched. 
      The source seems to be updated about <a target="_blank" href="https://github.com/nytimes/covid-19-data/commits/master">once a day</a>.</p>
    <h1 class="headline">What is the "tech stack"?</h1>
    <p class="mt-1">This is just a Vue.js app. There is no "server" behind it. 
      The UI framework is <a target="_blank" href="https://vuetifyjs.com/en/">Vuetify</a>, and the charts are made using <a target="_blank" href="https://www.chartjs.org/">Charts.js</a>.</p>
  </v-container>
</template>

<script>
export default {
  
}
</script>